import React from 'react';
import useSWR from 'swr';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { EffectFade, Navigation, Pagination } from 'swiper';
import PackageCardAlpha from "./../packageSidebar/PackageCardAlpha";

SwiperCore.use([Navigation, Pagination, EffectFade]);

const fetcher = (url) =>
  fetch(url, { headers: { "X-API-TOKEN": process.env.REACT_APP_API_TOKEN } })
    .then((res) => {
      if (!res.ok) throw new Error(`Network response was not ok: ${res.status}`);
      return res.json();
    });

function ShowCollection(props) {
  const API_URL = `${process.env.REACT_APP_API_FOLDER}list_collection/${props.cid}`;
  const { data, error, isLoading } = useSWR(API_URL, fetcher);

  const collection = data?.workshops ?? [];
  const collectionTitle = data?.title ?? '';
  const collectionDesc = data?.short_description ?? '';

  // Slider configuration for SWR slides
  const slctSlider = {
    slidesPerView: 1,
    speed: 1000,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: `.testi-next4-${props.cid}`,
      prevEl: `.testi-prev4-${props.cid}`,
    },
    breakpoints: {
      480: { slidesPerView: 1 },
      768: { slidesPerView: 2 },
      992: { slidesPerView: 3 },
    },
    observer: true,
    observeParents: true,
  };

  if (isLoading) {
    return (
      <div className={`upcoming-tour-area upcoming-tour-area-${props.cid} pt-110 pb-110 chain`}>
        <div className="container">
          {[1, 2, 3].map((idx) => (
            <Skeleton key={idx} height={200} style={{ marginBottom: '1rem' }} />
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    console.error(error);
    return <p>Error: {error.message}</p>;
  }

  // Define artform color mapping
  const artformColors = {
    music: "#367591",
    sound: "#009FE3",
    film: "#FBF299",
    art: "#E6007E",
    environment: "#6EBC86",
    writing: "#7B6A58",
    activism: "#E24259",
    performance: "#725283",
    video: "#ABD194",
    vr: "#4D4C4C"
  };

  // Generate slides
  const listItems = collection.map((workshop) => (
    <SwiperSlide key={workshop.short_url} className="swiper-slide">
      <PackageCardAlpha workshop={workshop} />
    </SwiperSlide>
  ));

  return (
    <div className={`upcoming-tour-area upcoming-tour-area-${props.cid} pt-110 pb-110 chain`}>
      <div className="container">
        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-lg-5 d-flex justify-content-lg-start justify-content-center">
            <div className="section-head-alpha text-lg-start text-center">
              <h2 className="text-white">{collectionTitle}</h2>
              <p className="text-white">{collectionDesc}</p>
            </div>
          </div>
          <div className="col-lg-7 d-flex justify-content-lg-end justify-content-center">
            <div className={`slider-arrows text-center d-lg-flex flex-row justify-content-center d-none gap-5 slider-arrows-${props.cid}`}>
              <div className={`testi-prev4 testi-prev4-${props.cid}`} tabIndex={0} role="button" aria-label="Previous slide">
                <i className="bi bi-arrow-left" />
              </div>
              <div className={`testi-next4 testi-next4-${props.cid}`} tabIndex={0} role="button" aria-label="Next slide">
                <i className="bi bi-arrow-right" />
              </div>
            </div>
          </div>
        </div>
        <div className="row align-items-center justify-content-center fadeffect">
          <div className="col-lg-12">
            <Swiper className="swiper upcoming-tour" {...slctSlider}>
              <div className="swiper-wrapper">
                {listItems}
              </div>
            </Swiper>
          </div>
        </div>
        <div className="row text-center d-flex justify-content-center">
          <div className="col-md-4">
            <a href={`/collection/${props.cid}`} className="button-outlined-primary upcoming-btn mt-50">View collection</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShowCollection;
